import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, MapPin, Clock, Phone } from "lucide-react";
import { studio, navLinks } from "../mock";

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="relative border-t border-border bg-background" data-testid="footer">
      <div className="container-x pt-20 pb-10">
        <div className="grid gap-14 lg:grid-cols-12">
          {/* Brand */}
          <div className="lg:col-span-5">
            <p className="display text-[clamp(3.5rem,8vw,7rem)] leading-[0.85] tracking-wide">
              AVALON
              <br />
              <span className="text-stroke">TATTOO</span>
              <br />
              COLLECTIVE
            </p>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-muted-foreground">
              {studio.tagline} {studio.description}
            </p>
          </div>

          {/* Links */}
          <div className="lg:col-span-2">
            <h4 className="eyebrow mb-6">Explore</h4>
            <ul className="space-y-3">
              {navLinks.map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    className="link-underline text-sm font-medium text-foreground/80 transition-colors hover:text-foreground"
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                  >
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Visit */}
          <div className="lg:col-span-5">
            <h4 className="eyebrow mb-6">Visit the Studio</h4>
            <div className="grid gap-6 sm:grid-cols-2">
              <div className="flex gap-3">
                <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                <div className="text-sm leading-relaxed">
                  <p className="font-semibold">{studio.address.line1}</p>
                  <p className="text-muted-foreground">
                    {studio.address.city}, {studio.address.province}, {studio.address.country}
                  </p>
                </div>
              </div>
              <div className="flex gap-3">
                <Clock className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                <div className="text-sm leading-relaxed">
                  <p className="font-semibold">{studio.hours.label}</p>
                  <p className="text-muted-foreground">
                    {studio.hours.open} – {studio.hours.close}
                  </p>
                </div>
              </div>
              <div className="flex gap-3 sm:col-span-2">
                <Phone className="mt-0.5 h-4 w-4 shrink-0 text-primary" />
                <div className="text-sm leading-relaxed">
                  <p className="font-semibold">Call for details</p>
                  <a href={studio.phoneHref} className="text-muted-foreground transition-colors hover:text-foreground">
                    {studio.phone}
                  </a>
                </div>
              </div>
            </div>
            <a
              href={studio.mapsLink}
              target="_blank"
              rel="noreferrer"
              className="mt-8 inline-flex items-center gap-2 border-b border-foreground/40 pb-1 text-[11px] font-semibold uppercase tracking-[0.22em] transition-colors hover:border-primary hover:text-primary"
              data-testid="footer-directions"
            >
              Get Directions <ArrowUpRight className="h-3.5 w-3.5" />
            </a>
          </div>
        </div>

        <div className="mt-16 flex flex-col gap-3 border-t border-border pt-6 text-[11px] uppercase tracking-[0.18em] text-muted-foreground sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} {studio.name}. All rights reserved.</p>
          <p>{studio.address.full}</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
